import React from "react";
import Content from "../../componenets/Content";

const About = () => {
  return (
    <>
      <Content header="" />
    </>
  );
};

export default About;
